module.exports = __webpack_public_path__ + "img/full2-min.2d41eeb3.png";